// Toast notification — replaces native alert()
(function() {
    var container = document.createElement('div');
    container.id = 'toast-container';
    container.style.cssText = 'position:fixed;top:24px;right:24px;z-index:99999;display:flex;flex-direction:column;gap:12px;pointer-events:none;';
    document.body.appendChild(container);

    window.showToast = function(message, type) {
        type = type || 'error';
        var colors = {
            error:   'background:#322249;color:white;',
            success: 'background:#10b981;color:white;',
            info:    'background:white;color:#322249;border:1px solid rgba(0,0,0,0.1);',
        };
        var icons = {
            error:   '<svg style="width:20px;height:20px;flex-shrink:0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke-width="2"/><path stroke-linecap="round" stroke-width="2" d="M12 8v4m0 4h.01"/></svg>',
            success: '<svg style="width:20px;height:20px;flex-shrink:0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>',
            info:    '<svg style="width:20px;height:20px;flex-shrink:0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke-width="2"/><path stroke-linecap="round" stroke-width="2" d="M12 16v-4m0-4h.01"/></svg>',
        };
        var toast = document.createElement('div');
        toast.style.cssText = 'display:flex;align-items:center;gap:12px;padding:14px 20px;border-radius:12px;font-size:14px;font-weight:500;max-width:400px;pointer-events:auto;box-shadow:0 8px 30px rgba(0,0,0,0.12);transform:translateX(120%);transition:transform .4s cubic-bezier(.22,1,.36,1),opacity .3s;' + (colors[type] || colors.error);
        toast.innerHTML = (icons[type] || icons.error) + '<span>' + message + '</span>';
        container.appendChild(toast);
        requestAnimationFrame(function() { toast.style.transform = 'translateX(0)'; });
        setTimeout(function() {
            toast.style.transform = 'translateX(120%)';
            toast.style.opacity = '0';
            setTimeout(function() { toast.remove(); }, 400);
        }, 4000);
    };

    // Override native alert
    window._originalAlert = window.alert;
    window.alert = function(msg) { window.showToast(msg, 'error'); };
})();

// Product Showcase — staggered fade-in when scrolled into view
(function() {
    var showcases = document.querySelectorAll('.product-showcase');
    if (!showcases.length) return;

    if (typeof IntersectionObserver === 'undefined') {
        showcases.forEach(function(el) { el.classList.add('is-visible'); });
        return;
    }

    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    showcases.forEach(function(el) { observer.observe(el); });
})();

// Scroll Reveal Text — words fade from gray to black on scroll
(function() {
    var containers = document.querySelectorAll('.scroll-reveal-text');
    if (!containers.length) return;

    containers.forEach(function(container) {
        // Wrap each word in a span — works with <p> tags or inline text
        var targets = container.querySelectorAll('p');
        if (!targets.length) targets = [container];
        var words = [];

        [].forEach.call(targets, function(el) {
            var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
                acceptNode: function(node) {
                    return node.parentNode && node.parentNode.closest('a')
                        ? NodeFilter.FILTER_REJECT
                        : NodeFilter.FILTER_ACCEPT;
                }
            }, false);
            var textNodes = [];
            var n;
            while ((n = walker.nextNode())) textNodes.push(n);

            textNodes.forEach(function(textNode) {
                var parts = textNode.nodeValue.split(/(\s+)/);
                if (parts.length === 1 && !/\S/.test(parts[0])) return;
                var frag = document.createDocumentFragment();
                parts.forEach(function(part) {
                    if (/\S/.test(part)) {
                        var span = document.createElement('span');
                        span.className = 'scroll-word';
                        span.textContent = part;
                        frag.appendChild(span);
                    } else if (part.length) {
                        frag.appendChild(document.createTextNode(part));
                    }
                });
                textNode.parentNode.replaceChild(frag, textNode);
            });

            el.querySelectorAll('.scroll-word').forEach(function(w) { words.push(w); });
        });

        if (!words.length) return;

        // Set initial style
        words.forEach(function(w) {
            w.style.transition = 'color 0.15s';
            w.style.color = '#F3DFEA';
        });

        function update() {
            var rect = container.getBoundingClientRect();
            var vh = window.innerHeight;
            // Progress: 0 when container enters viewport, 1 when it reaches top
            var progress = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));

            var total = words.length;
            var revealed = Math.floor(progress * total * 1.4); // 1.4x to finish before fully scrolled past

            for (var i = 0; i < total; i++) {
                words[i].style.color = i < revealed ? '#322249' : '#F3DFEA';
            }
        }

        window.addEventListener('scroll', update, { passive: true });
        update();
    });
})();

// FAQ Accordion — close others when one opens
document.querySelectorAll('details').forEach(function(detail) {
    detail.addEventListener('toggle', function() {
        if (!detail.open) return;
        var parent = detail.parentElement;
        if (!parent) return;
        parent.querySelectorAll('details[open]').forEach(function(d) {
            if (d !== detail) d.removeAttribute('open');
        });
    });
});

// Testimonial Audio — play/pause, stop others, ring progress
(function() {
    var btns = document.querySelectorAll('.testimonial-audio-btn');
    if (!btns.length) return;
    var current = null;
    var currentBtn = null;
    var raf = null;
    var CIRCUMFERENCE = 116.24; // 2 * PI * 18.5

    function reset(btn) {
        btn.querySelector('.testimonial-audio-play').classList.remove('hidden');
        btn.querySelector('.testimonial-audio-pause').classList.add('hidden');
        var ring = btn.querySelector('.testimonial-audio-ring circle');
        if (ring) ring.style.strokeDashoffset = CIRCUMFERENCE;
    }

    function updateRing() {
        if (!current || !currentBtn) return;
        var ring = currentBtn.querySelector('.testimonial-audio-ring circle');
        if (ring && current.duration) {
            var pct = current.currentTime / current.duration;
            ring.style.strokeDashoffset = CIRCUMFERENCE * (1 - pct);
        }
        if (!current.paused) raf = requestAnimationFrame(updateRing);
    }

    btns.forEach(function(btn) {
        var audio = null;
        btn.addEventListener('click', function() {
            if (!audio) {
                audio = new Audio(btn.dataset.audio);
                audio.addEventListener('ended', function() {
                    cancelAnimationFrame(raf);
                    reset(btn);
                    current = null;
                    currentBtn = null;
                });
            }
            if (audio.paused) {
                if (current && current !== audio) {
                    current.pause();
                    cancelAnimationFrame(raf);
                    btns.forEach(reset);
                }
                audio.play();
                current = audio;
                currentBtn = btn;
                btn.querySelector('.testimonial-audio-play').classList.add('hidden');
                btn.querySelector('.testimonial-audio-pause').classList.remove('hidden');
                raf = requestAnimationFrame(updateRing);
            } else {
                audio.pause();
                cancelAnimationFrame(raf);
                reset(btn);
                current = null;
                currentBtn = null;
            }
        });
    });
})();

// Footer Buy Bar — show after a checkout button was in viewport, hide near footer
(function() {
    var bar = document.querySelector('.footer-buy');
    if (!bar) return;
    var footer = document.querySelector('footer');
    var seen = false;

    var btns = document.querySelectorAll('.checkout-btn');
    var showAfter = 0;
    if (btns.length) {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    seen = true;
                    if (!showAfter) showAfter = entry.target.getBoundingClientRect().top + window.scrollY;
                }
            });
        }, { threshold: 0.5 });
        btns.forEach(function(btn) { observer.observe(btn); });
    }

    window.addEventListener('scroll', function() {
        if (!seen) return;
        var scrollY = window.scrollY;
        var hidePoint = footer
            ? footer.offsetTop - window.innerHeight - 300
            : Infinity;
        // Show only between first CTA position - 300px and footer
        if (scrollY > Math.max(showAfter - 300, 400) && scrollY < hidePoint) {
            bar.classList.remove('translate-y-full');
        } else {
            bar.classList.add('translate-y-full');
        }
    }, { passive: true });

    // Termine slider toggle
    var showBtn = bar.querySelector('.footer-buy-show-termine');
    var defaultBar = bar.querySelector('.footer-buy-default');
    var termineBar = bar.querySelector('.footer-buy-termine');
    if (!showBtn || !termineBar) return;

    var backBtn = bar.querySelector('.footer-buy-back');
    var nextBtn = bar.querySelector('.footer-buy-next');
    var track = bar.querySelector('.footer-buy-termine-track');
    var cards = track ? track.querySelectorAll('.footer-buy-termin-card') : [];
    var offset = 0;
    var visible = 3;

    function updateSlider() {
        if (!track || !cards.length) return;
        var cardW = cards[0].offsetWidth + 8; // gap-2 = 8px
        track.style.transform = 'translateX(-' + (offset * cardW) + 'px)';
        if (backBtn) backBtn.style.opacity = offset === 0 ? '0.3' : '1';
        var maxOffset = Math.max(0, cards.length - visible);
        if (nextBtn) nextBtn.style.opacity = offset >= maxOffset ? '0.3' : '1';
    }

    showBtn.addEventListener('click', function() {
        defaultBar.classList.add('hidden');
        termineBar.classList.remove('hidden');
        offset = 0;
        updateSlider();
    });

    if (backBtn) {
        backBtn.addEventListener('click', function() {
            if (offset > 0) { offset--; updateSlider(); }
        });
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', function() {
            var maxOffset = Math.max(0, cards.length - visible);
            if (offset < maxOffset) { offset++; updateSlider(); }
        });
    }

    // Click outside termine bar → go back to default
    document.addEventListener('click', function(e) {
        if (!termineBar.classList.contains('hidden') && !bar.contains(e.target)) {
            termineBar.classList.add('hidden');
            defaultBar.classList.remove('hidden');
        }
    });
})();

// Event Cards — hover to play video, pause others
(function() {
    var cards = document.querySelectorAll('.event-card');
    if (!cards.length) return;

    function getVideo(card) {
        return card.querySelector('video');
    }

    function loadAndPlay(video) {
        if (!video) return;
        // Load lazy sources if needed
        if (!video._loaded) {
            var sources = video.querySelectorAll('source[data-src]');
            if (sources.length) {
                sources.forEach(function(s) { s.src = s.dataset.src; });
                video.load();
            }
            video._loaded = true;
        }
        video.play && video.play().catch(function() {});
    }

    cards.forEach(function(card) {
        var video = getVideo(card);
        if (!video) return;
        var isHover = video.classList.contains('event-video--hover');

        if (!isHover) return; // First card autoplays via video component

        // Pause hover videos initially
        video.pause && video.pause();

        card.addEventListener('mouseenter', function() {
            // Pause all other event videos
            cards.forEach(function(c) {
                if (c === card) return;
                var v = getVideo(c);
                if (v) v.pause && v.pause();
            });
            loadAndPlay(video);
        });

        card.addEventListener('mouseleave', function() {
            video.pause && video.pause();
            // Resume first card
            var firstVideo = getVideo(cards[0]);
            if (firstVideo && !firstVideo.classList.contains('event-video--hover')) {
                firstVideo.play && firstVideo.play().catch(function() {});
            }
        });
    });
})();

// Product Features — toggle on mobile
document.querySelectorAll('.features-toggle').forEach(function(btn) {
    var label = btn.querySelector('.features-toggle-label');
    var icon = btn.querySelector('.features-toggle-icon');
    btn.addEventListener('click', function() {
        var container = btn.closest('.features-collapse');
        var open = container.classList.toggle('is-open');
        label.textContent = open ? 'Weniger anzeigen' : 'Mehr anzeigen';
        icon.style.transform = open ? 'rotate(180deg)' : '';
    });
});

// Product Standard — image overlaps 50% into white background
(function() {
    var imgs = document.querySelectorAll('.product-overlap-img');
    if (!imgs.length) return;

    function adjust(img) {
        var half = img.offsetHeight / 2;
        var section = img.closest('.product-standard');
        if (!section) return;
        var bg = section.querySelector('.product-overlap-bg');
        if (!bg) return;
        img.closest('div').style.marginBottom = -half + 'px';
        bg.style.paddingTop = half + 'px';
    }

    imgs.forEach(function(img) {
        if (img.complete && img.naturalHeight) adjust(img);
        else img.addEventListener('load', function() { adjust(img); });
    });

    window.addEventListener('resize', function() {
        imgs.forEach(function(img) { adjust(img); });
    });
})();

// Product Standard — showcase wrapper overlaps 50% into white background (cards stay on top)
(function() {
    var wrappers = document.querySelectorAll('.product-overlap-showcase');
    if (!wrappers.length) return;

    function adjust(wrapper) {
        var half = wrapper.offsetHeight / 2;
        var section = wrapper.closest('.product-standard');
        if (!section) return;
        var bg = section.querySelector('.product-overlap-bg');
        if (!bg) return;
        wrapper.style.marginBottom = -half + 'px';
        bg.style.paddingTop = half + 'px';
    }

    wrappers.forEach(function(wrapper) {
        adjust(wrapper);
        wrapper.querySelectorAll('img').forEach(function(m) {
            if (!m.complete || !m.naturalHeight) {
                m.addEventListener('load', function() { adjust(wrapper); });
            }
        });
        wrapper.querySelectorAll('video').forEach(function(v) {
            v.addEventListener('loadedmetadata', function() { adjust(wrapper); });
        });
    });

    window.addEventListener('resize', function() {
        wrappers.forEach(function(wrapper) { adjust(wrapper); });
    });
})();

// Product Showcase Videos — lazy-load src on first intersection, play when ≥50% visible
(function() {
    var videos = document.querySelectorAll('.showcase-video');
    if (!videos.length) return;

    function activateSources(v) {
        if (v._sourcesActivated) return;
        var sources = v.querySelectorAll('source[data-src]');
        if (sources.length) {
            sources.forEach(function(s) { s.src = s.dataset.src; });
            v.load();
        }
        v._sourcesActivated = true;
    }

    if (typeof IntersectionObserver === 'undefined') {
        videos.forEach(function(v) { activateSources(v); v.play && v.play().catch(function() {}); });
        return;
    }

    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var v = entry.target;
            var active = entry.intersectionRatio >= 0.5;
            if (active && !v._showcasePlaying) {
                activateSources(v);
                v._showcasePlaying = true;
                try { v.currentTime = 0; } catch (e) {}
                v.play && v.play().catch(function() {});
            } else if (!active && v._showcasePlaying) {
                v._showcasePlaying = false;
                v.pause && v.pause();
            }
        });
    }, { threshold: 0.5 });
    videos.forEach(function(v) { observer.observe(v); });
})();

// Lazy Video Loader — loads src and autoplays when visible, pauses when not
// Supports <source data-src> and data-src on <video> itself
(function() {
    var videos = document.querySelectorAll('.lazy-video');
    if (!videos.length) return;
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var video = entry.target;
            var hoverOnly = video.classList.contains('event-video--hover');
            if (entry.isIntersecting) {
                if (!video._loaded) {
                    // Activate <source data-src> tags
                    var sources = video.querySelectorAll('source[data-src]');
                    if (sources.length) {
                        sources.forEach(function(s) { s.src = s.dataset.src; });
                        video.load();
                    } else if (video.dataset.src) {
                        // Fallback: data-src on video element itself
                        video.src = video.dataset.src;
                    }
                    video._loaded = true;
                }
                if (!hoverOnly && !document.body.dataset.modalLocked && !video.dataset.autoplayBlocked) {
                    video.play && video.play().catch(function() {});
                }
            } else {
                video.pause && video.pause();
            }
        });
    }, { threshold: 0.25 });
    videos.forEach(function(v) { observer.observe(v); });
})();

// Orientation Journey Picker — desktop (md+) pill bar with single-select panel.
document.querySelectorAll('.orientation-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
        var group = btn.dataset.orientationGroup;
        var target = btn.dataset.orientationTarget;
        document.querySelectorAll('.orientation-btn[data-orientation-group="' + group + '"]').forEach(function(b) {
            b.dataset.active = 'false';
        });
        btn.dataset.active = 'true';
        document.querySelectorAll('.orientation-panel[data-orientation-group="' + group + '"]').forEach(function(p) {
            p.classList.add('hidden');
        });
        var panel = document.getElementById(target);
        if (panel) panel.classList.remove('hidden');
    });
});

// Orientation Mobile Cards — open fullscreen modal per path.
(function() {
    function openModal(modal) {
        if (!modal) return;
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
    }
    function closeModal(modal) {
        if (!modal) return;
        modal.classList.add('hidden');
        var anyOpen = document.querySelector('.orientation-modal:not(.hidden)');
        if (!anyOpen) document.body.style.overflow = '';
    }
    document.querySelectorAll('.orientation-card-trigger').forEach(function(btn) {
        btn.addEventListener('click', function() {
            openModal(document.getElementById(btn.dataset.orientationModalTarget));
        });
    });
    document.querySelectorAll('[data-orientation-modal-close]').forEach(function(btn) {
        btn.addEventListener('click', function() {
            closeModal(document.getElementById(btn.dataset.orientationModalClose));
        });
    });
    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.orientation-modal:not(.hidden)').forEach(closeModal);
    });
})();

// Orientation Video Play Button
document.querySelectorAll('.orientation-play-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
        var group = btn.dataset.orientationGroup;
        var video = document.querySelector('.orientation-video[data-orientation-group="' + group + '"]');
        if (!video) return;
        if (!video.src && video.dataset.src) {
            video.src = video.dataset.src;
        }
        if (video.paused) {
            video.play();
            btn.style.opacity = '0';
            btn.style.pointerEvents = 'none';
        } else {
            video.pause();
            btn.style.opacity = '1';
            btn.style.pointerEvents = '';
        }
        video.onended = function() {
            btn.style.opacity = '1';
            btn.style.pointerEvents = '';
        };
        video.onclick = function() {
            if (!video.paused) {
                video.pause();
                btn.style.opacity = '1';
                btn.style.pointerEvents = '';
            }
        };
    });
});

// Events Slider Navigation
document.querySelectorAll('[data-slider-prev]').forEach(function(btn) {
    var slider = document.getElementById(btn.dataset.sliderPrev);
    if (!slider) return;
    btn.addEventListener('click', function() {
        slider.scrollBy({ left: -370, behavior: 'smooth' });
    });
});
document.querySelectorAll('[data-slider-next]').forEach(function(btn) {
    var slider = document.getElementById(btn.dataset.sliderNext);
    if (!slider) return;
    btn.addEventListener('click', function() {
        slider.scrollBy({ left: 370, behavior: 'smooth' });
    });
});

// Audio CTA Button — WhatsApp-style waveform player
document.querySelectorAll('.hero-audio-btn').forEach(function(btn) {
    var audioSrc = btn.dataset.audio;
    if (!audioSrc) return;

    var label = btn.querySelector('.hero-audio-label');
    var playing = btn.querySelector('.hero-audio-playing');
    var barsEl = btn.querySelector('.hero-audio-bars');
    var timeEl = btn.querySelector('.hero-audio-time');
    var audio = null, raf = null, bars = [];


    // Lock dimensions after render to prevent shrinking on play
    requestAnimationFrame(function() {
        btn.style.minWidth = btn.offsetWidth + 'px';
        btn.style.minHeight = btn.offsetHeight + 'px';
    });

    var barCount = 28;
    for (var i = 0; i < barCount; i++) {
        var h = 20 + Math.random() * 80;
        var bar = document.createElement('span');
        bar.style.cssText = 'flex:1;border-radius:9px;transition:opacity .15s;background:currentColor;opacity:0.35;height:' + h + '%';
        barsEl.appendChild(bar);
        bars.push(bar);
    }

    function formatTime(s) {
        var m = Math.floor(s / 60);
        var sec = Math.floor(s % 60);
        return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    function updatePlayhead() {
        if (!audio) return;
        var pct = audio.duration ? audio.currentTime / audio.duration : 0;
        var active = Math.floor(pct * barCount);
        for (var j = 0; j < barCount; j++) {
            bars[j].style.opacity = j <= active ? '1' : '0.35';
        }
        timeEl.textContent = formatTime(audio.currentTime);
        if (!audio.paused) raf = requestAnimationFrame(updatePlayhead);
    }

    function showPlaying() {
        label.style.visibility = 'hidden';
        label.style.opacity = '0';
        playing.classList.remove('hidden');
        playing.classList.add('flex');
    }

    function showLabel() {
        cancelAnimationFrame(raf);
        playing.classList.add('hidden');
        playing.classList.remove('flex');
        bars.forEach(function(b) { b.style.opacity = '0.35'; });
        label.style.visibility = '';
        label.style.opacity = '1';
    }

    btn.addEventListener('click', function() {
        if (!audio) {
            audio = new Audio(audioSrc);
            audio.addEventListener('ended', function() {
                audio.currentTime = 0;
                showLabel();
            });
        }
        if (audio.paused) {
            audio.play();
            showPlaying();
            raf = requestAnimationFrame(updatePlayhead);
        } else {
            audio.pause();
            cancelAnimationFrame(raf);
            showLabel();
        }
    });
});

var newsletterForm = document.getElementById('newsletter-form');

// Newsletter form — Double Opt-In via Resend
if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
        e.preventDefault();

        var email = document.getElementById('email');
        var submitButton = document.getElementById('submit-button');
        var messageDiv = document.getElementById('message');
        var loader = newsletterForm.querySelector('.loader');
        var subscribedText = document.querySelector('.subscribed-text');
        var submitText = submitButton.querySelector('.submit-text');
        var consent = newsletterForm.querySelector('.newsletter-consent');
        var endpoint = newsletterForm.dataset.endpoint;

        messageDiv.textContent = '';
        messageDiv.style.color = '';

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
            messageDiv.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
            messageDiv.style.color = 'red';
            return;
        }
        if (consent && !consent.checked) {
            messageDiv.textContent = 'Bitte bestätige die Datenschutz-Einwilligung.';
            messageDiv.style.color = 'red';
            return;
        }

        submitButton.disabled = true;
        submitText.style.display = 'none';
        loader.style.display = 'block';

        var newsletterTurnstile = newsletterForm.querySelector('[name="cf-turnstile-response"]');
        fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                action: 'subscribe',
                email: email.value,
                turnstile_token: newsletterTurnstile ? newsletterTurnstile.value : '',
            }),
        })
        .then(function(response) {
            var ct = response.headers.get('content-type') || '';
            if (!ct.includes('application/json')) {
                if (!response.ok) throw new Error('Server-Fehler (' + response.status + ')');
                return {};
            }
            return response.json().then(function(data) {
                if (!response.ok) throw new Error(data.error || 'Fehler');
                return data;
            });
        })
        .then(function() {
            email.value = '';
            newsletterForm.reset();
            subscribedText.textContent = 'Bitte überprüfe dein Postfach und bestätige deine Anmeldung.';
            subscribedText.style.display = 'block';
            newsletterForm.style.display = 'none';
        })
        .catch(function(error) {
            messageDiv.textContent = error.message || 'Ein Fehler ist aufgetreten. Bitte versuche es später erneut.';
            messageDiv.style.color = 'red';
        })
        .finally(function() {
            submitButton.disabled = false;
            submitText.style.display = 'block';
            loader.style.display = 'none';
        });
    });
}

// Kontaktformular — POST an Supabase Edge Function (contact-submit)
document.querySelectorAll('.contact-form').forEach(function(form) {
    var startedAt = form.querySelector('input[name="started_at"]');
    if (startedAt) startedAt.value = String(Date.now());

    form.addEventListener('submit', function(e) {
        e.preventDefault();

        var endpoint   = form.dataset.endpoint;
        var successMsg = form.dataset.success;
        var btn        = form.querySelector('.contact-submit');
        var btnText    = form.querySelector('.contact-submit-text');
        var loader     = form.querySelector('.contact-loader');
        var msg        = form.querySelector('.contact-message');
        var successBox = form.parentElement.querySelector('.contact-success');
        var successP   = successBox && successBox.querySelector('p');

        msg.classList.add('hidden');
        msg.textContent = '';
        msg.style.color = '';

        var turnstileInput = form.querySelector('[name="cf-turnstile-response"]');
        var payload = {
            first_name: (form.first_name.value || '').trim(),
            last_name:  (form.last_name.value  || '').trim(),
            email:      (form.email.value      || '').trim(),
            message:    (form.message.value    || '').trim(),
            website:    (form.website.value    || ''),  // honeypot
            started_at: parseInt(startedAt ? startedAt.value : '0', 10) || 0,
            page_url:   window.location.href,
            recipient:  form.dataset.recipient || '',
            subject:    form.dataset.subject   || '',
            turnstile_token: turnstileInput ? turnstileInput.value : '',
        };

        if (!payload.first_name || !payload.last_name) {
            msg.textContent = 'Bitte gib Vor- und Nachnamen an.';
            msg.style.color = '#dc2626';
            msg.classList.remove('hidden');
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
            msg.textContent = 'Bitte gib eine gültige E-Mail-Adresse an.';
            msg.style.color = '#dc2626';
            msg.classList.remove('hidden');
            return;
        }
        if (payload.message.length < 10) {
            msg.textContent = 'Deine Nachricht ist zu kurz.';
            msg.style.color = '#dc2626';
            msg.classList.remove('hidden');
            return;
        }
        var contactConsent = form.querySelector('.contact-consent');
        if (contactConsent && !contactConsent.checked) {
            msg.textContent = 'Bitte bestätige die Datenschutz-Einwilligung.';
            msg.style.color = '#dc2626';
            msg.classList.remove('hidden');
            return;
        }

        btn.disabled = true;
        if (btnText) btnText.style.display = 'none';
        if (loader)  loader.classList.remove('hidden');

        fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
        .then(function(response) {
            return response.json().then(function(data) {
                if (!response.ok) throw new Error(data.error || 'Versand fehlgeschlagen.');
                return data;
            });
        })
        .then(function() {
            form.reset();
            if (startedAt) startedAt.value = String(Date.now());
            form.classList.add('hidden');
            if (successBox && successP) {
                successP.textContent = successMsg || 'Vielen Dank für deine Nachricht!';
                successBox.classList.remove('hidden');
            }
        })
        .catch(function(error) {
            msg.textContent = error.message || 'Ein Fehler ist aufgetreten. Bitte versuche es später erneut.';
            msg.style.color = '#dc2626';
            msg.classList.remove('hidden');
        })
        .finally(function() {
            btn.disabled = false;
            if (btnText) btnText.style.display = '';
            if (loader)  loader.classList.add('hidden');
        });
    });
});

// Feedback-Widget — Token-Check + Submit an Supabase Edge Functions
document.querySelectorAll('.feedback-widget').forEach(function(widget) {
    var checkEndpoint  = widget.dataset.checkEndpoint;
    var submitEndpoint = widget.dataset.submitEndpoint;
    var successMsg     = widget.dataset.success;
    var submittedMsg   = widget.dataset.submitted;
    var invalidMsg     = widget.dataset.invalid;
    var missingMsg     = widget.dataset.missing;

    var loading   = widget.querySelector('.feedback-loading');
    var info      = widget.querySelector('.feedback-info');
    var infoText  = widget.querySelector('.feedback-info-text');
    var form      = widget.querySelector('.feedback-form');
    var productEl = widget.querySelector('.feedback-product');
    var productNameEl = widget.querySelector('.feedback-product-name');
    var stars     = widget.querySelectorAll('.feedback-star');
    var ratingInput = form.querySelector('input[name="rating"]');
    var messageEl = form.querySelector('textarea[name="message"]');
    var submitBtn = form.querySelector('.feedback-submit');
    var submitTxt = form.querySelector('.feedback-submit-text');
    var loader    = form.querySelector('.feedback-loader');
    var errorEl   = form.querySelector('.feedback-message');
    var publishToggle  = form.querySelector('.feedback-publish-toggle');
    var publishOptions = form.querySelector('.feedback-publish-options');
    var publishModeEls = form.querySelectorAll('input[name="publish_mode"]');
    var publishNameEl  = form.querySelector('.feedback-publish-name');

    if (publishToggle) {
        publishToggle.addEventListener('change', function() {
            publishOptions.classList.toggle('hidden', !publishToggle.checked);
            if (!publishToggle.checked) {
                publishNameEl.classList.add('hidden');
                publishNameEl.value = '';
                publishModeEls.forEach(function(el) { el.checked = el.value === 'anonymous'; });
            }
        });
    }
    publishModeEls.forEach(function(el) {
        el.addEventListener('change', function() {
            var named = el.value === 'named' && el.checked;
            publishNameEl.classList.toggle('hidden', !named);
            if (!named) publishNameEl.value = '';
        });
    });

    function showState(state) {
        loading.classList.add('hidden');
        info.classList.add('hidden');
        form.classList.add('hidden');
        if (state === 'loading') loading.classList.remove('hidden');
        if (state === 'info')    info.classList.remove('hidden');
        if (state === 'form')    form.classList.remove('hidden');
    }

    function showInfo(text) {
        infoText.textContent = text;
        showState('info');
    }

    function showError(text) {
        errorEl.textContent = text;
        errorEl.style.color = '#dc2626';
        errorEl.classList.remove('hidden');
    }

    function setRating(value) {
        ratingInput.value = String(value);
        stars.forEach(function(s) {
            var v = parseInt(s.dataset.value, 10);
            var active = v <= value;
            s.classList.toggle('text-nmotb-pink', active);
            s.classList.toggle('text-nmotb-black/20', !active);
            s.setAttribute('aria-checked', active ? 'true' : 'false');
        });
    }

    stars.forEach(function(s) {
        s.addEventListener('click', function() {
            setRating(parseInt(s.dataset.value, 10));
        });
    });

    var token = new URLSearchParams(window.location.search).get('t') || '';
    if (!token) {
        showInfo(missingMsg);
        return;
    }

    fetch(checkEndpoint + '?token=' + encodeURIComponent(token), { method: 'GET' })
        .then(function(r) { return r.json(); })
        .then(function(data) {
            if (data.status === 'valid') {
                if (data.productLabel) {
                    productNameEl.textContent = data.productLabel;
                    productEl.classList.remove('hidden');
                }
                showState('form');
            } else if (data.status === 'submitted') {
                showInfo(submittedMsg);
            } else {
                showInfo(invalidMsg);
            }
        })
        .catch(function() {
            showInfo(invalidMsg);
        });

    form.addEventListener('submit', function(e) {
        e.preventDefault();
        errorEl.classList.add('hidden');

        var rating  = parseInt(ratingInput.value, 10) || 0;
        var message = (messageEl.value || '').trim();

        if (rating < 1 && message.length < 3) {
            showError('Bitte gib eine Bewertung ab oder schreib eine kurze Nachricht.');
            return;
        }

        var publishAllowed = !!(publishToggle && publishToggle.checked);
        var publishMode = 'anonymous';
        publishModeEls.forEach(function(el) { if (el.checked) publishMode = el.value; });
        var publishName = publishAllowed && publishMode === 'named' ? (publishNameEl.value || '').trim() : '';

        if (publishAllowed && publishMode === 'named' && publishName.length < 2) {
            showError('Bitte gib deinen Vornamen ein oder wähle „anonym veröffentlichen".');
            return;
        }

        submitBtn.disabled = true;
        if (submitTxt) submitTxt.style.display = 'none';
        if (loader)    loader.classList.remove('hidden');

        fetch(submitEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                token: token,
                rating: rating,
                message: message,
                publish_allowed: publishAllowed,
                publish_name: publishName,
            }),
        })
        .then(function(response) {
            return response.json().then(function(data) {
                if (!response.ok) throw new Error(data.error || 'Versand fehlgeschlagen.');
                return data;
            });
        })
        .then(function() {
            showInfo(successMsg);
        })
        .catch(function(err) {
            showError(err.message || 'Ein Fehler ist aufgetreten. Bitte versuche es später erneut.');
        })
        .finally(function() {
            submitBtn.disabled = false;
            if (submitTxt) submitTxt.style.display = '';
            if (loader)    loader.classList.add('hidden');
        });
    });
});

// Testimonials — Mehr-lesen Button nur zeigen, wenn der Text mehr als 4 Zeilen
// hat. Modal öffnen/schließen via Klick, ESC und Klick außerhalb.
(function() {
    var texts = document.querySelectorAll('.testimonial-text');
    if (!texts.length) return;

    function checkOverflow() {
        texts.forEach(function(el) {
            // line-clamp blendet überlaufende Zeilen aus — scrollHeight > clientHeight
            // verrät, dass abgeschnitten wurde.
            var btn = el.parentElement && el.parentElement.querySelector('.testimonial-more');
            if (!btn) return;
            if (el.scrollHeight - el.clientHeight > 1) {
                btn.classList.remove('hidden');
            } else {
                btn.classList.add('hidden');
            }
        });
    }
    checkOverflow();
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(checkOverflow);
    }
    window.addEventListener('resize', checkOverflow);

    function openModal(modal) {
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        document.body.style.overflow = 'hidden';
    }
    function closeModal(modal) {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        if (!document.querySelector('.testimonial-modal.flex')) {
            document.body.style.overflow = '';
        }
    }

    document.querySelectorAll('.testimonial-more').forEach(function(btn) {
        btn.addEventListener('click', function() {
            var modal = document.getElementById(btn.dataset.modal);
            if (modal) openModal(modal);
        });
    });

    document.querySelectorAll('.testimonial-modal').forEach(function(modal) {
        modal.addEventListener('click', function(e) {
            if (e.target === modal) closeModal(modal);
        });
        var closeBtn = modal.querySelector('.testimonial-modal-close');
        if (closeBtn) closeBtn.addEventListener('click', function() { closeModal(modal); });
    });

    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.testimonial-modal.flex').forEach(closeModal);
    });
})();

// Hero-Video-Overlay: Trigger öffnet Overlay, lädt + startet das Full-Video,
// pausiert die Float-Preview und sperrt den Body-Scroll. Close (Button oder
// Klick außerhalb) entsperrt wieder.
(function() {
    // Cross-Browser-zuverlässiges Scroll-Lock: position-fixed mit Erhalt der
    // Scroll-Position. Funktioniert auch auf iOS, wo `overflow:hidden` allein
    // die Page nicht zuverlässig sperrt.
    var lockCount = 0;
    var unlockTimer = null;
    function lockScroll() {
        if (unlockTimer) { clearTimeout(unlockTimer); unlockTimer = null; }
        if (lockCount++ > 0) return;
        var y = window.scrollY || window.pageYOffset || 0;
        document.body.dataset.scrollLockY = String(y);
        // Flag wird vom lazy-video Observer geprüft, damit Layout-Shifts beim
        // Modal-Open keine .lazy-video Elemente fälschlich starten.
        document.body.dataset.modalLocked = '1';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + y + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
    }
    function unlockScroll() {
        if (--lockCount > 0) return;
        if (lockCount < 0) lockCount = 0;
        var y = parseInt(document.body.dataset.scrollLockY || '0', 10);
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        delete document.body.dataset.scrollLockY;
        window.scrollTo(0, y);
        // Layout snappt nach scrollTo zurück — Observer feuert nochmal. Erst
        // nach kurzem Delay den Lock-Flag entfernen, damit der Observer in der
        // Übergangs-Phase noch nichts startet.
        unlockTimer = setTimeout(function() {
            delete document.body.dataset.modalLocked;
            unlockTimer = null;
        }, 350);
    }

    function openOverlay(overlay, triggerEl) {
        var preview = triggerEl.parentElement && triggerEl.parentElement.querySelector('video');
        if (preview) preview.pause();
        // Sobald der User ein Hero-Video bewusst startet: alle bisher autoplayten
        // lazy-videos pausieren UND für die restliche Session vom Autoplay
        // ausschließen, damit nach dem Modal-Close nicht beim Scrollen plötzlich
        // andere Videos losgehen.
        document.querySelectorAll('.lazy-video').forEach(function(v) {
            v.pause && v.pause();
            v.dataset.autoplayBlocked = '1';
        });
        var v = overlay.querySelector('video');
        if (v && !v.src && overlay.dataset.src) v.src = overlay.dataset.src;
        overlay.style.display = 'flex';
        if (v) { v.muted = false; v.play().catch(function(){}); }
        lockScroll();
    }
    function closeOverlay(overlay) {
        var v = overlay.querySelector('video');
        if (v) v.pause();
        overlay.style.display = 'none';
        unlockScroll();
    }

    document.querySelectorAll('.hero-video-trigger').forEach(function(trigger) {
        trigger.addEventListener('click', function() {
            var overlay = document.getElementById(trigger.dataset.overlay);
            if (overlay) openOverlay(overlay, trigger);
        });
    });

    document.querySelectorAll('.hero-video-overlay').forEach(function(overlay) {
        overlay.addEventListener('click', function(e) {
            if (e.target === overlay) closeOverlay(overlay);
        });
        var closeBtn = overlay.querySelector('.hero-video-close');
        if (closeBtn) closeBtn.addEventListener('click', function() { closeOverlay(overlay); });
    });

    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.hero-video-overlay').forEach(function(overlay) {
            if (overlay.style.display !== 'none' && overlay.style.display !== '') closeOverlay(overlay);
        });
    });
})();

// Waitlist forms — schickt nur Email + Page/Block-ID an die Kirby-Route.
// Audience-Name wird server-side im Kirby-Content nachgeschlagen.
document.querySelectorAll('.waitlist-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
        e.preventDefault();

        var emailInput = form.querySelector('.waitlist-email');
        var consentInput = form.querySelector('.waitlist-consent');
        var submitButton = form.querySelector('.waitlist-submit');
        var submitText = form.querySelector('.waitlist-submit-text');
        var loader = form.querySelector('.waitlist-loader');
        var messageDiv = form.querySelector('.waitlist-message');
        var content = form.closest('.waitlist-content');
        var successText = form.parentElement.parentElement.querySelector('.waitlist-success');
        var endpoint = form.dataset.endpoint;
        var pageId = form.querySelector('input[name="page"]').value;
        var blockId = form.querySelector('input[name="block"]').value;
        var honeypot = form.querySelector('input[name="website"]').value;

        messageDiv.textContent = '';
        messageDiv.style.color = '';

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value)) {
            messageDiv.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
            messageDiv.style.color = '#7a1a1a';
            return;
        }
        if (!consentInput.checked) {
            messageDiv.textContent = 'Bitte bestätige die Einwilligung.';
            messageDiv.style.color = '#7a1a1a';
            return;
        }

        submitButton.disabled = true;
        submitText.classList.add('hidden');
        loader.classList.remove('hidden');

        var waitlistTurnstile = form.querySelector('[name="cf-turnstile-response"]');
        fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: emailInput.value,
                page: pageId,
                block: blockId,
                consent: true,
                website: honeypot,
                turnstile_token: waitlistTurnstile ? waitlistTurnstile.value : '',
            }),
        })
        .then(function(response) {
            return response.json().then(function(data) {
                if (!response.ok) throw new Error(data.error || 'Fehler');
                return data;
            });
        })
        .then(function() {
            form.reset();
            if (content) content.style.display = 'none';
            else form.style.display = 'none';
            if (successText) successText.classList.remove('hidden');
        })
        .catch(function(error) {
            messageDiv.textContent = error.message || 'Ein Fehler ist aufgetreten.';
            messageDiv.style.color = '#7a1a1a';
        })
        .finally(function() {
            submitButton.disabled = false;
            submitText.classList.remove('hidden');
            loader.classList.add('hidden');
        });
    });
});

(function() {
    if (!window.gsap || !window.ScrollTrigger) return;
    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    document.querySelectorAll('.app-section').forEach(function(section) {
        var textEls = section.querySelectorAll('.app-anim-el');
        var phoneLg = section.querySelector('.app-phone--large');
        var phoneSm = section.querySelector('.app-phone--small');

        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top 80%',
                end: 'bottom 15%',
                scrub: 1,
            }
        });

        textEls.forEach(function(el, i) {
            gsap.set(el, { opacity: 0, x: -80 });
            tl.to(el, { opacity: 1, x: 0, duration: 0.12, ease: 'power2.out' }, 0.02 + i * 0.05);
        });
        if (phoneLg) {
            gsap.set(phoneLg, { opacity: 0, y: 500 });
            tl.to(phoneLg, { opacity: 1, y: 0, duration: 0.4, ease: 'power3.out' }, 0.05);
        }
        if (phoneSm) {
            gsap.set(phoneSm, { opacity: 0, y: 600 });
            tl.to(phoneSm, { opacity: 1, y: 0, duration: 0.4, ease: 'power3.out' }, 0.1);
        }

        tl.to({}, { duration: 0.1 }, 0.45);

        textEls.forEach(function(el, i) {
            tl.to(el, { opacity: 0, x: -60, duration: 0.12, ease: 'power2.in' }, 0.55 + i * 0.03);
        });
        if (phoneLg) {
            tl.to(phoneLg, { opacity: 0, y: 400, duration: 0.35, ease: 'power3.in' }, 0.6);
        }
        if (phoneSm) {
            tl.to(phoneSm, { opacity: 0, y: 500, duration: 0.35, ease: 'power3.in' }, 0.63);
        }
    });

    document.querySelectorAll('.podcast-section').forEach(function(section) {
        var els = section.querySelectorAll('.podcast-anim-el');

        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top 80%',
                end: 'bottom 15%',
                scrub: 1,
            }
        });

        els.forEach(function(el, i) {
            gsap.set(el, { opacity: 0, x: -80 });
            tl.to(el, { opacity: 1, x: 0, duration: 0.12, ease: 'power2.out' }, 0.02 + i * 0.05);
        });

        tl.to({}, { duration: 0.1 }, 0.45);

        els.forEach(function(el, i) {
            tl.to(el, { opacity: 0, x: -60, duration: 0.12, ease: 'power2.in' }, 0.55 + i * 0.03);
        });
    });
})();

// Digital-Content-Consent (§356 Abs. 5 BGB) — Kauf-Button erst freischalten
// wenn Checkbox angehakt ist.
document.querySelectorAll('.digital-consent-checkbox').forEach(function(cb) {
    cb.addEventListener('change', function() {
        var pageId = cb.dataset.target;
        var btns = document.querySelectorAll('.checkout-btn[data-page-id="' + pageId + '"][data-requires-consent="1"]');
        btns.forEach(function(b) { b.disabled = !cb.checked; });
    });
});

// Checkout — creates Stripe session via Kirby route
document.querySelectorAll('.checkout-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
        if (btn.disabled) return;

        var digitalConsent = false;
        if (btn.dataset.requiresConsent === '1') {
            var cb = document.querySelector('.digital-consent-checkbox[data-target="' + btn.dataset.pageId + '"]');
            if (!cb || !cb.checked) {
                alert('Bitte bestätige den Hinweis zum Widerrufsrecht, bevor du fortfährst.');
                return;
            }
            digitalConsent = true;
        }

        var btnText = btn.querySelector('.btn-text');
        var btnLoad = btn.querySelector('.btn-loading');

        btn.disabled = true;
        if (btnText) btnText.classList.add('hidden');
        if (btnLoad) btnLoad.classList.remove('hidden');

        fetch('/checkout/create', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                page_id: btn.dataset.pageId,
                termin_id: btn.dataset.terminId || null,
                digital_consent: digitalConsent,
            }),
        })
        .then(function(res) {
            return res.json().then(function(data) {
                if (!res.ok) throw new Error(data.error || 'Fehler');
                return data;
            });
        })
        .then(function(data) {
            if (data.url) window.location.href = data.url;
        })
        .catch(function(err) {
            alert(err.message || 'Ein Fehler ist aufgetreten.');
        })
        .finally(function() {
            btn.disabled = false;
            btnText.classList.remove('hidden');
            btnLoad.classList.add('hidden');
        });
    });
});

// Video Float — mini loop preview, click to open full video
(function() {
    document.querySelectorAll('.video-float').forEach(function(container) {
        var playBtn   = container.querySelector('.video-float-play-overlay');
        var preview   = container.querySelector('.video-float-preview');
        var overlayEl = container.nextElementSibling;

        console.log('video-float init', container.id, 'overlay:', overlayEl);

        if (!playBtn || !overlayEl || !overlayEl.classList.contains('video-float-overlay')) {
            console.warn('video-float: missing overlay for', container.id);
            return;
        }

        var fullVideo = overlayEl.querySelector('.video-float-full');
        var closeBtn  = overlayEl.querySelector('.video-float-overlay-close');
        var loaded    = false;

        document.body.appendChild(overlayEl);

        playBtn.addEventListener('click', function(e) {
            console.log('video-float play clicked', container.id);
            e.preventDefault();
            e.stopPropagation();
            if (preview) preview.pause();

            if (!loaded && fullVideo) {
                var src = overlayEl.dataset.src;
                console.log('loading full video:', src);
                if (src) fullVideo.src = src;
                loaded = true;
            }

            overlayEl.style.display = 'flex';
            if (fullVideo) {
                fullVideo.currentTime = 0;
                fullVideo.muted = false;
                fullVideo.play().catch(function(err) { console.warn('play failed:', err); });
            }
        });

        function closeOverlay() {
            if (fullVideo) fullVideo.pause();
            overlayEl.style.display = 'none';
            if (preview) preview.play().catch(function() {});
        }

        if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
        overlayEl.addEventListener('click', function(e) {
            if (e.target === overlayEl) closeOverlay();
        });
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && overlayEl.style.display === 'flex') closeOverlay();
        });
    });
})();

// Preview Fade — wechselt Vorschaubilder mit 2000ms Crossfade
(function () {
    var FADE = 1000;  // muss mit CSS transition matchen
    var HOLD = 3000;
    document.querySelectorAll('.preview-fade').forEach(function (el) {
        var items = Array.from(el.querySelectorAll(':scope > .preview-fade-item'));
        if (items.length <= 1) {
            if (items[0]) items[0].classList.add('is-active');
            return;
        }
        var idx = 0;
        items[0].classList.add('is-active');
        setInterval(function () {
            items[idx].classList.remove('is-active');
            idx = (idx + 1) % items.length;
            items[idx].classList.add('is-active');
        }, FADE + HOLD);
    });
})();